import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { OrdersDashboard } from './pages/OrdersDashboard';
import { OrderDetail } from './pages/OrderDetail';
import { CreateOrder } from './pages/CreateOrder';
import { LenderManagement } from './pages/LenderManagement';
function Header() {
  return <header className="sticky top-0 z-50 h-16 bg-white border-b border-slate-100 flex items-center px-8" data-id="element-0">
      <h1 className="text-xl font-semibold tracking-tight" style={{
      color: 'var(--nmhl-burgundy)'
    }} data-id="element-1">
        Loan Orders
      </h1>
    </header>;
}
export function App() {
  return <BrowserRouter data-id="element-2">
      <div className="min-h-screen bg-slate-50" data-id="element-3">
        <Header data-id="element-4" />
        <main className="min-h-screen" data-id="element-5">
          <div className="max-w-7xl mx-auto px-8 py-12" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<Navigate to="/orders" replace data-id="element-9" />} data-id="element-8" />
              <Route path="/orders" element={<OrdersDashboard data-id="element-11" />} data-id="element-10" />
              <Route path="/orders/new" element={<CreateOrder data-id="element-13" />} data-id="element-12" />
              <Route path="/orders/:orderId" element={<OrderDetail data-id="element-15" />} data-id="element-14" />
              <Route path="/lenders" element={<LenderManagement data-id="element-17" />} data-id="element-16" />
            </Routes>
          </div>
        </main>
      </div>
    </BrowserRouter>;
}